import * as React from 'react';
// import Stack from '@mui/material/Stack';
// import Button from '@mui/material/Button';

export default function BasicButtons({text, h1}) {
  return (
    // <Stack spacing={2} direction="row">
    <>
    {h1}
      <button>{text}</button>
    </>
    // </Stack>
  );
}


